export default {
  title01: "موجودہ موسم",
  title02: "24 گھنٹے",
  title03: "10 دن کی موسم کی پیشن گوئی دیکھیں",
  title04: "AQI",
  title05: "تمام معلومات دیکھیں",
  title06: "سورج اور غروب آفتاب",
  title07: "چاند کا مرحلہ",
  title08: "اگلا پورا چاند",
  title09: "اگلا نیا چاند",
  title10: "دن",
  title11: "رات",
  title12: "سورج",
  title13: "غروب آفتاب",
  title14: "چاند طلوع",
  title15: "چاند ڈھلنا",
  title16: "ماخذ",
  title17: "شروع کریں",
  title18: "ختم",
  title19: "موجودہ مقام استعمال کریں",
  title20: "شہر کی تلاش کریں",
  title21: "ایسا محسوس ہوتا ہے",
  title22: "سایہ کی طرح محسوس ہوتا ہے",
  title23: "اب",
  title24: "آج",
  title25: "اتوار",
  title26: "پیر",
  title27: "منگل",
  title28: "بدھ",
  title29: "جمعرات",
  title30: "جمعہ",
  title31: "ہفتہ",
  title32: "لوڈ ہو رہا ہے...",
  title33: "اب",
  title34: "فی گھنٹہ",
  title35: "روزانہ",
  title36: "سورج اور چاند",
  title37: "ہوا کا معیار",
  title38: "پر رابطہ کریں: xlf550402@gmail.com",
  title39: "رازداری کا معاہدہ",
  title40: "کاپی رائٹ © comfortweather.com 2020 - 2025۔ تمام حق محفوظ ہیں۔",
  title41: "",
  title42: "اعلی درجہ حرارت",
  title43: "کم درجہ حرارت",
  title44: "قبول کریں",
  title45:
    'ComfortWeather  کا استعمال کرنے کے لئے شکریہ! آپ کے قانون حقوق اور منافع کو اچھی حفاظت کرنے کے لئے  آپ استعمال سے پہلے "خصوصی پولیسی" کو اچھی طرح پڑھ لیں. ',
  Title46: "حفاظتی پالیسی",
  title47: " استعمال سے پہلےاحتیاط",
  title48: "کے ذریعہ فراہم کردہ ڈیٹا",
  title49: "پر رابطہ کریں: xyjph123@gmail.com",
  title50: "کاپی رائٹ © 24hweather.com 2020 - 2025۔ تمام حق محفوظ ہیں۔",
  title51:
    '24hweather  کا استعمال کرنے کے لئے شکریہ! آپ کے قانون حقوق اور منافع کو اچھی حفاظت کرنے کے لئے  آپ استعمال سے پہلے "خصوصی پولیسی" کو اچھی طرح پڑھ لیں. ',
};
